import React, { Component } from "react";
import { Link } from "react-router-dom";
import Navigation from "./navigation.js";
import Footer from "./footer.js";
import HeroImage from "./heroimage.js";
import GalleryContainer from "./galleryContainer.js";
import SampleGallery from './sampleGallery.js';


const image3 = require("../samples/storage-solutions/alcove-units/Aldsworth Attic Bookcases & cupboards (2).jpg");
const image4 = require("../samples/storage-solutions/alcove-units/Aldsworth Attic Bookcases & cupboards (3).jpg");
const image5 = require("../samples/storage-solutions/alcove-units/Aldsworth Attic Bookcases & cupboards (6).jpg");
const image6 = require("../samples/storage-solutions/alcove-units/Crouch End Alcoves 3.jpg");
const image7 = require("../samples/storage-solutions/alcove-units/Crouch End Alcoves 4.jpg");
const image8 = require("../samples/storage-solutions/alcove-units/Crouch End Alcoves 5.jpg");
const image9 = require("../samples/storage-solutions/alcove-units/Crouch End Alcoves 6.jpg");
const image10 = require("../samples/storage-solutions/alcove-units/Crouch End Alcoves 7.jpg");
const image11 = require("../samples/storage-solutions/alcove-units/Crouch End Alcoves.jpg");
const image12 = require("../samples/storage-solutions/alcove-units/Derwent Road 1.jpg");
const image13 = require("../samples/storage-solutions/alcove-units/Derwent Road.jpg");
const image14 = require("../samples/storage-solutions/alcove-units/Great Dunmow.jpg");
const image15 = require("../samples/storage-solutions/alcove-units/Guido Marsan  (2).jpg");
const image16 = require("../samples/storage-solutions/alcove-units/Guido Marsan  (3).jpg");
const image17 = require("../samples/storage-solutions/alcove-units/Hawthorn Road.jpg");
const image18 = require("../samples/storage-solutions/alcove-units/Highgate Close N6 (4).JPG");
const image19 = require("../samples/storage-solutions/alcove-units/Highgate Close N6 (7).JPG");
const image20 = require("../samples/storage-solutions/alcove-units/Highgate Close N6 (10).JPG");
const image21 = require("../samples/storage-solutions/alcove-units/Highgate Close N6 (11).JPG");
const image22 = require("../samples/storage-solutions/alcove-units/Highgate Close N6 (13).JPG");
const image23 = require("../samples/storage-solutions/alcove-units/Highgate Close N6 (14).JPG");
const image24 = require("../samples/storage-solutions/alcove-units/image4.jpeg");
const image25 = require("../samples/storage-solutions/alcove-units/image5.jpeg");
const image26 = require("../samples/storage-solutions/alcove-units/image6.jpeg");
const image27 = require("../samples/storage-solutions/alcove-units/Loughton Alcove.jpg");
const image28 = require("../samples/storage-solutions/alcove-units/loughton.jpg");
const image29 = require("../samples/storage-solutions/alcove-units/Pewters Avenue 3.jpg");
const image30 = require("../samples/storage-solutions/alcove-units/Pewters Avenue 4.2.jpg");
const image31 = require("../samples/storage-solutions/alcove-units/Pewters Avenue 4.jpg");
const image32 = require("../samples/storage-solutions/alcove-units/Pewters Avenue 5.1.jpg");
const image33= require("../samples/storage-solutions/alcove-units/Pewters Avenue 7.jpg");
const image34 = require("../samples/storage-solutions/alcove-units/Pewters Avenue.jpg");
const image35 = require("../samples/storage-solutions/alcove-units/Rita Cornwell (2).JPG");
const image36 = require("../samples/storage-solutions/alcove-units/Rita Cornwell Alcove units (5).JPG");
const image37 = require("../samples/storage-solutions/alcove-units/Rita Cornwell Alcove units (7).JPG");
const image38 = require("../samples/storage-solutions/alcove-units/Rita Cornwell Alcove units.JPG");
const image39 = require("../samples/storage-solutions/alcove-units/Rita Cornwell Bedroom Alcoves (6).JPG");
const image40 = require("../samples/storage-solutions/alcove-units/Rita Cornwell Bedroom Alcoves.JPG");
const image41 = require("../samples/storage-solutions/alcove-units/Sophie Himsworth Alcove Units (3).jpg");
const image42 = require("../samples/storage-solutions/alcove-units/Sophie Himsworth Alcove Units (4).jpg");
const image43 = require("../samples/storage-solutions/alcove-units/Sophie Himsworth Alcove Units (5).jpg");
const image44 = require("../samples/storage-solutions/alcove-units/Sophie Himsworth Alcove Units.jpg");
const image45 = require("../samples/storage-solutions/alcove-units/St Georges Road Alcove Unit (9).jpg");
const image46 = require("../samples/storage-solutions/alcove-units/St Georges Road Alcove Unit (10).jpg");
const image47 = require("../samples/storage-solutions/alcove-units/St Georges Road Alcove Unit (11).jpg");
const image48 = require("../samples/storage-solutions/alcove-units/Terrick Road Alcove Units (4).jpg");
const image49 = require("../samples/storage-solutions/alcove-units/Terrick Road Alcove Units (8).jpg");
const image50 = require("../samples/storage-solutions/alcove-units/Terrick Road Alcove Units (12).jpg");
const image51 = require("../samples/storage-solutions/alcove-units/The Terrace Alcoves 2.jpg");
const image52= require("../samples/storage-solutions/alcove-units/The Terrace Alcoves 3.jpg");
const image53 = require("../samples/storage-solutions/alcove-units/The Terrace Alcoves 4.jpg");
const image54 = require("../samples/storage-solutions/alcove-units/The Terrace Alcoves 5.jpg");
const image55 = require("../samples/storage-solutions/alcove-units/The Terrace Alcoves 6.jpg");
const image56 = require("../samples/storage-solutions/alcove-units/The Terrace Alcoves 7.jpg");
const image57 = require("../samples/storage-solutions/alcove-units/The terrace Alcoves 8.jpg");
const image58 = require("../samples/storage-solutions/alcove-units/The Terrace Alcoves.jpg");
const image59 = require("../samples/storage-solutions/alcove-units/Uplands Road N8 (21).JPG");
const image60 = require("../samples/storage-solutions/alcove-units/Uplands Road N8 (22).JPG");
const image61 = require("../samples/storage-solutions/alcove-units/Uplands Road N8 (24).JPG");
const image62 = require("../samples/storage-solutions/alcove-units/Wagner Alcove Units (3).jpg");
const image63 = require("../samples/storage-solutions/alcove-units/Wagner Alcove Units (5).jpg");

let images =
[{
    src: image3,
    thumbnail: image3,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image4,
    thumbnail: image4,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image5,
    thumbnail: image5,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image6,
    thumbnail: image6,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image7,
    thumbnail: image7,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image8,
    thumbnail: image8,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image9,
    thumbnail: image9,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image10,
    thumbnail: image10,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image11,
    thumbnail: image11,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image12,
    thumbnail: image12,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image13,
    thumbnail: image13,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image14,
    thumbnail: image14,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image15,
    thumbnail: image15,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image16,
    thumbnail: image16,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image17,
    thumbnail: image17,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image18,
    thumbnail: image18,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image19,
    thumbnail: image19,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image20,
    thumbnail: image20,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image21,
    thumbnail: image21,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image22,
    thumbnail: image22,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image23,
    thumbnail: image23,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image24,
    thumbnail: image24,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image25,
    thumbnail: image25,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image26,
    thumbnail: image26,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image27,
    thumbnail: image27,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image28,
    thumbnail: image28,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image29,
    thumbnail: image29,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image30,
    thumbnail: image30,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image31,
    thumbnail: image31,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image32,
    thumbnail: image32,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image33,
    thumbnail: image33,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image34,
    thumbnail: image34,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image35,
    thumbnail: image35,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image36,
    thumbnail: image36,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image37,
    thumbnail: image37,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image38,
    thumbnail: image38,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image39,
    thumbnail: image39,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image40,
    thumbnail: image40,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image41,
    thumbnail: image41,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image42,
    thumbnail: image42,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image43,
    thumbnail: image43,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image44,
    thumbnail: image44,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
    src: image45,
    thumbnail: image45,
    thumbnailWidth: 300,
    thumbnailHeight: 320,
},{
src: image46,
thumbnail: image46,
thumbnailWidth: 300,
thumbnailHeight: 320,
},{
src: image47,
thumbnail: image47,
thumbnailWidth: 300,
thumbnailHeight: 320,
},{
src: image48,
thumbnail: image48,
thumbnailWidth: 300,
thumbnailHeight: 320,
},{
src: image49,
thumbnail: image49,
thumbnailWidth: 300,
thumbnailHeight: 320,
},{
src: image50,
thumbnail: image50,
thumbnailWidth: 300,
thumbnailHeight: 320,
},{
src: image51,
thumbnail: image51,
thumbnailWidth: 300,
thumbnailHeight: 320,
},{
src: image52,
thumbnail: image52,
thumbnailWidth: 300,
thumbnailHeight: 320,
},{
src: image53,
thumbnail: image53,
thumbnailWidth: 300,
thumbnailHeight: 320,
},{
src: image54,
thumbnail: image54,
thumbnailWidth: 300,
thumbnailHeight: 320,
},{
src: image55,
thumbnail: image55,
thumbnailWidth: 300,
thumbnailHeight: 320,
},{
src: image56,
thumbnail: image56,
thumbnailWidth: 300,
thumbnailHeight: 320,
},{
src: image57,
thumbnail: image57,
thumbnailWidth: 300,
thumbnailHeight: 320,
},{
src: image58,
thumbnail: image58,
thumbnailWidth: 300,
thumbnailHeight: 320,
},{
src: image59,
thumbnail: image59,
thumbnailWidth: 300,
thumbnailHeight: 320,
},{
src: image60,
thumbnail: image60,
thumbnailWidth: 300,
thumbnailHeight: 320,
},{
src: image61,
thumbnail: image61,
thumbnailWidth: 300,
thumbnailHeight: 320,
},{
src: image62,
thumbnail: image62,
thumbnailWidth: 300,
thumbnailHeight: 320,
},{
src: image63,
thumbnail: image63,
thumbnailWidth: 300,
thumbnailHeight: 320,
}
]


class Storage extends Component {
  render() {
    return (
      <div>
        <Navigation />
        <div className="spacer"></div>
        <HeroImage content="STORAGE SOLUTIONS" />
        <Link to="/samples">
        <div className='backtosamples'>&larr; Back to samples</div>
        </Link>
        <div className="sampleImageContainer">
            <SampleGallery images={images}></SampleGallery>
        </div>   
        <div className="spacer"></div>
        <div className="spacer"></div>
        <div className="spacer"></div>
        <div className="spacer"></div>
        <Footer />
      </div>
    );
  }
}
export default Storage;
